<template>
  <div class="setting-post-time-page">
    <ins-selector v-model="selectPublisherId"></ins-selector>
    <div class="right-container">
      <div class="header-container">Default Caption or Comment</div>
      <div class="main-container">
        <div class="tip-text">{{ topMsg }}</div>
        <manager-tab class="tab-container" :tab-list="tabList"></manager-tab>
        <caption-form
          class="form-container"
          v-show="tabList[0].select"
          type="caption"
          :socialNetwork="socialNetwork"
          :publisher-id="selectPublisherId"
        ></caption-form>
        <caption-form
          class="form-container"
          v-show="tabList[1].select"
          type="comment"
          :socialNetwork="socialNetwork"
          :publisher-id="selectPublisherId"
        ></caption-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import insSelector from "../../components/common/instagram_selector/Selector";
import ManagerTab from "../../components/setting/ManagerTab";
import CaptionForm from "../../components/setting/default_caption/From";

export default {
  name: "SettingDefaultCaptionPage",
  components: { CaptionForm, ManagerTab, insSelector },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    topMsg() {
      if (this.socialNetwork !== "twitter") {
        return "We will randomly auto apply your default caption or comment when you schedule posts.";
      } else {
        return "We will randomly auto apply your default tweet or reply when you schedule posts.";
      }
    },
    socialNetwork() {
      const selectPublisher = this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.selectPublisherId
      );
      if (selectPublisher) {
        if (selectPublisher.socialNetwork === 4) {
          return "twitter";
        }
      }
      return "";
    },
  },
  data() {
    return {
      selectPublisherId: "",
      tabList: [
        { id: "caption", text: "Caption", select: true, hide: false },
        { id: "comment", text: "First Comment", select: false, hide: false },
      ],
    };
  },
  watch: {
    async selectPublisherId(val, old) {
      // 获取当前选中的publisher信息
      const selectPublisher = this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.selectPublisherId
      );
      // 如果选中的是facebook group则没有comment
      if (selectPublisher.socialNetwork === 3) {
        // 隐藏comment 同时选中caption
        this.tabList[1].hide = true;
        this.tabList[0].select = true;
        this.tabList[1].select = false;
      } else {
        this.tabList[1].hide = false;
      }
      if (selectPublisher.socialNetwork === 4) {
        this.tabList[0].text = "Tweet";
        this.tabList[1].text = "First Reply";
      } else {
        this.tabList[0].text = "Caption";
        this.tabList[1].text = "First Comment";
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.setting-post-time-page {
  display: flex;
  flex: 1;

  .right-container {
    flex: 1;
    height: 100vh;

    .header-container {
      height: 80px;
      border-bottom: 1px solid @border-color;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      padding-left: 40px;
    }

    .main-container {
      display: flex;
      flex-direction: column;
      height: calc(~"100vh - 80px");
      min-width: 700px;
      .tip-text {
        margin-top: 40px;
        margin-bottom: 15px;
        padding: 0 40px;
      }

      .tab-container {
        margin: 0 40px 20px 40px;
      }

      .form-container {
        flex: 1;
        padding: 0 40px;
      }
    }
  }
}
</style>
